module.exports = __webpack_public_path__ + "assets/img/17_1038_big.10c5568c.jpg";